export var chipCustomCssProperties = {
  text: "--smar--core--chip--text",
  backgroundRest: "--smar--core--chip--background--rest",
  backgroundHover: "--smar--core--chip--background--hover",
  backgroundActive: "--smar--core--chip--background--active",
  removeButtonOpacity: "--smar--core--chip--remove--button--opacity"
};
var semanticTokenTextMap = {
  "in-progress": "info",
  completed: "success",
  "at-risk": "warning",
  blocked: "error"
};
var semanticTokenBackgroundMap = {
  "in-progress": "blue",
  completed: "green",
  "at-risk": "gold",
  blocked: "red"
};
var isSemanticColor = function isSemanticColor(color) {
  return color in semanticTokenBackgroundMap;
};
export var getTokenForColor = function getTokenForColor(color, themeMode) {
  switch (themeMode) {
    case "lodestar-light":
      return getTokenForColorLodestar(color);
    default:
      return getTokenForColorDefault(color);
  }
};
var getTokenForColorDefault = function getTokenForColorDefault(color) {
  // Not-started remaps to neutral.
  if (color !== "not-started" && isSemanticColor(color)) {
    var semanticTextMapping = semanticTokenTextMap[color];
    var semanticBackgroundMapping = semanticTokenBackgroundMap[color];
    return {
      text: "color--text--".concat(semanticTextMapping, "--default"),
      backgroundRest: "color--background--spectrum-".concat(semanticBackgroundMapping, "--weakest"),
      backgroundHover: "color--background--spectrum-".concat(semanticBackgroundMapping, "--weaker"),
      backgroundActive: "color--background--spectrum-".concat(semanticBackgroundMapping, "--weak")
    };
  } else {
    if (color === "not-started") {
      color = "neutral";
    }
    return {
      text: "color--text--spectrum-".concat(color, "--strong"),
      backgroundRest: "color--background--spectrum-".concat(color, "--weakest"),
      backgroundHover: "color--background--spectrum-".concat(color, "--weaker"),
      backgroundActive: "color--background--spectrum-".concat(color, "--weak")
    };
  }
};
var semanticTokenTextMapLodestar = {
  "in-progress": "info",
  completed: "success",
  "at-risk": "warning",
  blocked: "error"
};
var semanticTokenBackgroundMapLodestar = {
  "in-progress": "info",
  completed: "success",
  "at-risk": "warning",
  blocked: "error"
};

/**
 * Kinda lame that we need to do this, but Lodestar's Tag and Token components have a much darker
 * theme we want to support since we're upgrading people directly from the Tag/Token to Chip.
 */
var getTokenForColorLodestar = function getTokenForColorLodestar(color) {
  // Not-started remaps to neutral.
  if (color !== "not-started" && isSemanticColor(color)) {
    var semanticTextMapping = semanticTokenTextMapLodestar[color];
    var semanticBackgroundMapping = semanticTokenBackgroundMapLodestar[color];
    return {
      text: "color--text--".concat(semanticTextMapping, "--default"),
      backgroundRest: "color--background--".concat(semanticBackgroundMapping, "--weaker"),
      backgroundHover: "color--background--".concat(semanticBackgroundMapping, "--weak"),
      backgroundActive: "color--background--".concat(semanticBackgroundMapping, "--default")
    };
  } else {
    if (color === "not-started") {
      color = "neutral";
    }
    return {
      text: "color--text--spectrum-".concat(color, "--strong"),
      backgroundRest: "color--background--spectrum-".concat(color, "--weak"),
      backgroundHover: "color--background--spectrum-".concat(color, "--default"),
      backgroundActive: "color--background--spectrum-".concat(color, "--strong")
    };
  }
};
//# sourceMappingURL=chipConstants.js.map